import { z as s } from "zod";
const c = s.custom((e) => typeof e == "object" && e !== null && "seconds" in e && "nanoseconds" in e && typeof e.seconds == "number" && typeof e.nanoseconds == "number");
function i(e) {
  return e.seconds * 1e3 + e.nanoseconds / 1e6;
}
function o(e) {
  return new Date(i(e));
}
class n {
  constructor(t, a) {
    this.seconds = t, this.nanoseconds = a;
  }
  toMillis() {
    return i(this);
  }
  toDate() {
    return o(this);
  }
  static fromMillis(t) {
    return new n(Math.floor(t / 1e3), t % 1e3 * 1e6);
  }
  static fromDate(t) {
    return n.fromMillis(t.getTime());
  }
}
let r = n;
function m(e) {
  r = e;
}
const f = s.codec(c, s.date(), {
  decode: (e) => o(e),
  encode: (e) => r.fromDate(e)
}), u = s.codec(s.iso.date(), c, {
  decode: (e) => r.fromDate(/* @__PURE__ */ new Date(e + "T00:00:00Z")),
  encode: (e) => o(e).toISOString().split("T")[0]
}), p = (e, t) => e.includes(t), l = (e) => Object.keys(e), T = (e) => typeof e == "object" && e !== null ? Object.fromEntries(
  Object.entries(e).filter(
    ([, t]) => typeof t != "string" || t.trim().length > 0
  )
) : e;
export {
  u as I,
  f as T,
  p as i,
  T as r,
  m as s,
  l as t
};
//# sourceMappingURL=base-DFJERsUx.js.map
